import React from "react";
import T4LOSReportUI from "./T4LOSReportUI";

function App() {
  return <T4LOSReportUI />;
}

export default App;
